export default __webpack_public_path__ + "locales/fr/Settings.json?hash=22edc27c3b61570e73e7ec8effe05e7e";